import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=5270b36f&scoped=true"
import script from "@/controllers/componentHooks/button/index.js?vue&type=script&lang=js&external"
export * from "@/controllers/componentHooks/button/index.js?vue&type=script&lang=js&external"
import style0 from "./Button.css?vue&type=style&index=0&id=5270b36f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270b36f",
  null
  
)

export default component.exports